import { render, staticRenderFns } from "./MercadolibreAuthorize.vue?vue&type=template&id=2c8a5155&scoped=true"
import script from "./MercadolibreAuthorize.vue?vue&type=script&lang=js"
export * from "./MercadolibreAuthorize.vue?vue&type=script&lang=js"
import style0 from "./MercadolibreAuthorize.vue?vue&type=style&index=0&id=2c8a5155&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8a5155",
  null
  
)

export default component.exports